// @flow
import React, { Component } from 'react'
import Switcher from '../controls/Switcher'
import LabeledWrapper from './LabeledWrapper'
import { translateFunc, translations } from '../../shared/localize'

type Props = {|
  value: string,
  onChange: (string) => void
|}

const t = translateFunc(translations.geograhpy)

export default class Geography extends Component<Props> {
  render() {
    const { value, onChange } = this.props

    return (
      <LabeledWrapper label={t('label')}>
        <Switcher
          value={value}
          options={[
            { name: t('cities'), id: 'cities' },
            { name: t('micro'), id: 'micro' }
          ]}
          onChange={(val) => onChange(val)}
        />
      </LabeledWrapper>
    )
  }
}
